import { SVGInterface } from "../../interface";

const Mobile = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M17 23H7C5.89543 23 5 22.1046 5 21V2.913C5.04661 1.84255 5.92853 0.998988 7 1H17C18.1046 1 19 1.89543 19 3V21C19 22.1046 18.1046 23 17 23ZM7 3V21H17V3H15C15 4.10457 14.1046 5 13 5H11C9.89543 5 9 4.10457 9 3H7Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Mobile;
